import { Button, Form, Input, message } from 'antd';
import { FC, ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutSite } from '../components/layout';
import { Loader } from '../components/loader';
import { import_file_us, preview_import_file_us } from '../services/api.service';
import './importus.scss';
import { APIAnswer, APIAnswerData, MLCompetitor, MLRace } from '../types';
import { ArrowLeftOutlined, DownOutlined, FileAddOutlined, FileTextOutlined, UpOutlined } from '@ant-design/icons';

/* -------------------------------------------------------------------------------- *\
|                               ImportUSPage
\* -------------------------------------------------------------------------------- */
export const ImportUSPage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [loading, setLoading] = useState(true);
    const [selectedtab, setSelectedTab] = useState<string>("races");
    const [previewraces, setPreviewRaces] = useState<MLRace[]>([]);
    const navigate = useNavigate();
    const [inputfilekey, setinputfilekey] = useState<string>('key_0');
    const [openRaces, setOpenRaces] = useState<Set<number>>(new Set());

    /* -------------------------------------------------------------------------------- *\
    |                               toggleRace / toggleAllRaces
    \* -------------------------------------------------------------------------------- */
    function toggleRace(index: number)
    {
        const next = new Set(openRaces);
        if (next.has(index)) next.delete(index);
        else next.add(index);
        setOpenRaces(next);
    }

    function toggleAllRaces()
    {
        if (openRaces.size > 0) setOpenRaces(new Set());
        else setOpenRaces(new Set(previewraces.map((_, i) => i)));
    }

    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true);
        setSelectedTab("races");
        setLoading(false);
        // eslint-disable-next-line
    }, [])

    const [file, setFile] = useState<File | null>(null);
    const [preview, setPreview] = useState<string>('');

    /* -------------------------------------------------------------------------------- *\
    |                               handleUpload
    \* -------------------------------------------------------------------------------- */
    function handleUpload(event)
    {
        const e: HTMLInputElement = event.target;
        if (e.files && e.files[0])
        {
            const f: File = e.files[0];
            setFile(f);

            var reader = new FileReader();
            reader.addEventListener('load', (e) =>
            {
                if (e.loaded === e.total)
                {
                    try
                    {
                        setPreview(e.target?.result as string);
                        setPreviewRaces([]);
                        setOpenRaces(new Set());
                        preview_import_file_us(e.target?.result as string)
                        .then((data: APIAnswerData) => { setPreviewRaces(data.data); })
                        .catch((error) => { message.info(error); });
                    }
                    catch(error)
                    {
                        setPreview('Error reading file : ' + error);
                    }
                    setinputfilekey(inputfilekey.split('_')[0] + '_' + (parseInt(inputfilekey.split('_')[1]) + 1));
                }
            });
            reader.readAsText(f as Blob);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               onFinishUpload
    \* -------------------------------------------------------------------------------- */
    function onFinishUpload()
    {
        var reader = new FileReader();
        reader.addEventListener('load', (e) =>
        {
            if (e.loaded === e.total)
            {
                import_file_us(e.target?.result as string)
                .then((answer: APIAnswer) =>
                {
                    if (answer.status)
                    {
                        message.info("import succeded");
                        navigate("/");
                    }
                    else
                    {
                        message.error("An error occured while importing: " + answer.message);
                    }
                })
                .catch((error) => { message.info(error); })
            }
        });
        reader.readAsText(file as Blob);
    }

    return (
        <LayoutSite>
            <div className="importus">
                {loading ? <Loader /> : <></>}
                <div className="importus__header">
                    <div>
                        <button className="importtracks__header__back" onClick={() => navigate("/tracks")}>
                            <ArrowLeftOutlined />
                            calendar
                        </button>
                    </div>
                </div>
                <div className="importus__body">
                    <div className="importus__body__title">Import race from XML USA file</div>
                    <Form name="importus__body__form" className="importus__body__form" onFinish={() => onFinishUpload()}>
                        <Form.Item label='File'>
                            <div className="importus-form-file-wrapper">
                                <div className="importus-form-file-container">
                                    <FileAddOutlined style={{ fontSize: "24px" }} />
                                    <h4 className="importus-form-file-title">Add your XML file to see the preview or import</h4>
                                </div>
                                <Input className="importus-form-file" type="file" hidden={true} onChange={handleUpload} key={inputfilekey} accept=".xml" />
                            </div>
                        </Form.Item>
                        {
                            file &&
                            <p className="importus-form-file-name">
                                <FileTextOutlined style={{ fontSize: "16px" }} />
                                {file?.name}
                            </p>
                        }
                        <Form.Item className="importus__body__form__toolbar">
                            <Button type="primary" htmlType="submit" disabled={!file}>Import</Button>
                        </Form.Item>
                    </Form>
                    {
                        preview &&
                        <>
                            <div className='importus__body__preview__buttons'>
                                <Button size='small' onClick={() => setSelectedTab("races")}>Races</Button>
                                <Button size='small' onClick={() => setSelectedTab("text")}>Text</Button>
                            </div>

                            {
                                selectedtab === 'races' &&
                                <>
                                    <Button className="importus-preview-close" size='small' type="primary" onClick={toggleAllRaces}>
                                        {openRaces.size > 0 ? "Close All" : "Open All"}
                                    </Button>
                                    <div className='importus-preview'>
                                        <div className='importus-preview-races'>
                                            {
                                                previewraces?.map((race: MLRace, index: number) =>
                                                {
                                                    const date = new Date(race.date);

                                                    return (
                                                        <div className="importus-preview-race" key={index} onClick={() => toggleRace(index)}>
                                                            <div className="importus-preview-race-container">
                                                                <div className="importus-preview-race-line">
                                                                    <div>C{race.number}</div>
                                                                    <div>{!isNaN(date.getTime()) ? date.toLocaleTimeString().substring(0, 5) : ''}</div>
                                                                    <div> - {race.distance}m</div>
                                                                    <div> - <span className={race.trackcode === "XXX" ? "importus-trackcode-invalid" : undefined}>{race.trackcode}</span></div>
                                                                    <div>{" - count=" + race.competitors.length}</div>
                                                                    <div> {race.name}</div>
                                                                </div>
                                                                <div style={{ cursor: 'pointer' }}>
                                                                    {openRaces.has(index) ? <UpOutlined style={{ fontSize: "20px" }} /> : <DownOutlined style={{ fontSize: "20px" }} />}
                                                                </div>
                                                            </div>
                                                            {
                                                                openRaces.has(index) && race.competitors.map((horse: MLCompetitor, i: number) =>
                                                                {
                                                                    return (
                                                                        <div key={i} className="importus-preview-race-horse">
                                                                            <div>{horse.number}</div>
                                                                            <div>{horse.name}</div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                selectedtab === 'text' &&
                                <div className='importus__body__preview'>
                                    <div className='importus__body__preview__races'>{preview ? preview : ''}</div>
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
        </LayoutSite>
    );
}
